import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useAuth } from '../App';
import { API } from '../utils';
import { toast } from 'sonner';
import axios from 'axios';
import { CreditCard, ArrowRight } from 'lucide-react';

const SetupPayments = () => {
  const [connecting, setConnecting] = useState(false);
  const { token } = useAuth();
  const navigate = useNavigate();
  const config = { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} };

  const handleConnectStripe = async () => {
    setConnecting(true);
    try {
      await axios.post(`${API}/connect/create-account`, {}, config);
      const response = await axios.post(`${API}/connect/onboarding-link`, {
        origin_url: window.location.origin
      }, config);
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to connect Stripe');
      setConnecting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#FAFAFA]">
      <div className="w-full max-w-lg animate-fadeInUp">
        <div className="flex items-center justify-center mb-12">
          <span className="text-3xl font-bold tracking-tight">FrameFinder</span>
        </div>

        <div className="bg-white rounded-2xl p-8 border border-gray-100">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-black text-white mx-auto mb-6">
            <CreditCard className="w-8 h-8" strokeWidth={1.5} />
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">Set up payments</h1>
          <p className="text-gray-500 text-center mb-8">
            Connect your Stripe account to receive payments directly when clients approve your work. You can also do this later in your profile settings.
          </p>

          <div className="bg-gray-50 rounded-xl p-4 mb-6 space-y-2 text-sm text-gray-600">
            <p>✓ Get paid automatically when work is approved</p>
            <p>✓ Funds held securely in escrow until delivery</p>
            <p>✓ Payouts typically arrive within 2–3 business days</p>
          </div>

          <Button
            onClick={handleConnectStripe}
            disabled={connecting}
            className="w-full h-12 rounded-full bg-black text-white hover:bg-gray-900 mb-3"
          >
            {connecting ? 'Redirecting to Stripe...' : 'Connect with Stripe'}
          </Button>

          <button
            onClick={() => navigate('/edit-profile')}
            className="w-full h-12 rounded-full border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors text-sm flex items-center justify-center gap-2"
          >
            Skip for now <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetupPayments;
